module.exports = __webpack_public_path__ + "img/snow_dark.66b29956.svg";